import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import * as style from './ArticleTableOfContents.module.scss';
import { ReactComponent as ChevronRightIcon } from '../../../assets/vectors/Chevron-right.svg';

/**
 * Tables of contents contains anchors to different parts of current article.
 */
const ArticleTableOfContents = (props) => {
  // eslint-disable-next-line no-unused-vars
  const { anchorsList, onAnchorLinkClick } = props;

  return (
    <div className={style.tableOfContents}>
      {anchorsList?.map((anchor, index) => (
        <Link
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          to={anchor?.tocAnchorLink}
          className={`clearLinkStyle d-block ${style.link}`}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onAnchorLinkClick(e);
          }}
        >
          <div className={style.linkText}>{anchor?.tocText}</div>
          <ChevronRightIcon width={20} height={20} />
        </Link>
      ))}
    </div>
  );
};

ArticleTableOfContents.propTypes = {
  /** Array of anchor objects: { tocAnchorLink, tocText } */
  anchorsList: PropTypes.array.isRequired,
  /** A function ro handle clicks on anchor links */
  onAnchorLinkClick: PropTypes.func.isRequired,
};

export default ArticleTableOfContents;
